import NavigatorWidgetUI from '@/components/navigator-widget-ui/navigator-widget-ui.vue';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'facets-search',
    components: {
        'navigator-widget-ui': NavigatorWidgetUI,
    },
})
export default class FacetSearch extends Vue {

    // --------------------------------------------------------------
    // Properties

    // -------------------------------------------------------------
    // Hooks


    // -------------------------------------------------------------
    // Actions

    // -------------------------------------------------------------
    // Methods




}
